// extracted by mini-css-extract-plugin
export default {"viewContainer":"AITutorCodeEditorModality__viewContainer___QCd89"};